/**
 * De vaste gelaagdheid van de hele app (webshop én beheer), van laag naar hoog.
 *
 * In className altijd de naam gebruiken (`z-header`, `z-overlay`), nooit een getal:
 * de lintregel in eslint.config.js weigert `z-50` en `z-[60]`. De namen staan in
 * tailwind.config.js (theme.extend.zIndex); dit bestand spiegelt ze voor de plekken
 * waar een getal nodig is (Sonner krijgt `style={{ zIndex }}`). Gelijk houden.
 *
 *   raised   10  iets net boven zijn buren binnen een kaart of lijst
 *   sticky   20  plakkende kop binnen een pagina (bovenbalk beheer)
 *   nav      30  vaste navigatie van het beheer (zijbalk, tabbalk, opslaanbalk)
 *   bar      40  vaste balken van de webshop onderin (actiebalk, koopbalk, Vraag Sarah)
 *   header   50  kop van de webshop
 *   overlay  60  lades, modale vensters, mobiel menu van het beheer. Een datumkiezer of
 *                popover ín een overlay hoort binnen die overlay; die krijgt `z-raised`.
 *   toast    70  meldingen: altijd boven een open lade, zodat "Ongedaan maken" bereikbaar is
 *   skip     80  de skiplink: bij focus boven alles
 */
export const LAYERS = {
  raised: 10,
  sticky: 20,
  nav: 30,
  bar: 40,
  header: 50,
  overlay: 60,
  toast: 70,
  skip: 80,
} as const

export const TOAST_LAYER = LAYERS.toast
